export const trackAccountRegistration = ({
  action,
}: {
  action: 'registration_submitted_successfully';
}) => {
  const event = {
    event: 'account_registration_conversion',
    action: action,
    label: '',
    value: null,
  };

  return event;
};
